import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function UnsubscribeDataFailed() {
  const texts = useTexts()

  return (
    <Alert severity="error">
      <AlertTitle>{texts.unsubscribeDataFailureTitle}</AlertTitle>
      {texts.unsubscribeDataFailureDescription}
    </Alert>
  )
}
